// extracted by mini-css-extract-plugin
export default {"extraTable":"UserStyle_extraTable__T18ID"};